<template>
  <b-row class="mx-0 mb-2 p-0" v-if="isLocked">
    <b-col cols="12" class="px-0">
      <b-alert
        show
        variant="warning"
        class="d-flex align-items-center mb-0"
      >
        <i
          class="fas fa-exclamation-triangle mr-2"
          style="font-size: 1.1rem"
        ></i>
        <div class="flex-grow-1">
          <strong>Hóa đơn này đã được tạo hóa đơn GTGT.</strong>
          Các trường hợp chỉnh sửa cần liên hệ kế toán để được hỗ trợ.
          <template v-if="einvoice.invoiceNo">
            <span class="mx-2">|</span>
            Số HĐĐT: <strong>{{ einvoice.invoiceNo }}</strong>
          </template>
          <template v-if="issuedAtDisplay">
            <span class="mx-2">|</span>
            Ngày phát hành: {{ issuedAtDisplay }}
          </template>
        </div>
        <EInvoiceStatusBadge
          class="ml-2"
          size="sm"
          :work-state="einvoice.workState"
          :invoice-no="einvoice.invoiceNo"
          :pattern="einvoice.pattern"
          :serial="einvoice.serial"
          :issued-at="einvoice.issuedAt"
          :tax-status="einvoice.taxStatus"
          :error-message="einvoice.errorMessage"
        />
      </b-alert>
    </b-col>
  </b-row>
</template>

<script>
  import moment from 'moment'
  import EInvoiceStatusBadge from '@/view/components/bills/EInvoiceStatusBadge.vue'

  export default {
    name: 'BillEInvoiceLockAlert',
    components: { EInvoiceStatusBadge },
    props: {
      einvoice: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      isLocked() {
        const ws = this.einvoice && this.einvoice.workState
        return Boolean(ws && ws !== 'none')
      },
      issuedAtDisplay() {
        const issuedAt = this.einvoice && this.einvoice.issuedAt
        if (!issuedAt) return ''
        const m = moment(issuedAt)
        return m.isValid() ? m.format('DD/MM/YYYY') : ''
      },
    },
  }
</script>
